/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * TAF Delivery API
 * OpenAPI spec version: 1.0
 */

export type MembershipPageContentModelContentType = typeof MembershipPageContentModelContentType[keyof typeof MembershipPageContentModelContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MembershipPageContentModelContentType = {
  membershipPage: 'membershipPage',
} as const;
